import ConfirmDeleteAstraDebitCardModal from './ConfirmDeleteInstantFundingDebitCardModal';

export default ConfirmDeleteAstraDebitCardModal;
